module.exports = __webpack_public_path__ + "assets/img/monkeyQR.1952c660213d944ce5890e1cf2d83fb0.svg";